<script lang="ts" setup>
import { useSwiper } from '~/composables/common/use-swiper'
import { promotionItems, promotionModalItems } from '~/resources/promotion'
import { SlidersPerView, PromotionRouteEnum } from '~/enums'
import { usePromotionalEngagement } from '~/composables/tracking-events/use-promotional-engagement'
import type { HomePromotionItem } from '~/types/promotion'
const { modules, SwiperSlide, Swiper } = useSwiper()
const { EVENT_ENABLE } = useRuntimeConfig().public
const props = defineProps({
  title: {
    type: String,
    required: false,
    default: null,
  },
  icon: {
    type: String,
    required: false,
    default: null,
  },
  hasViewMore: {
    type: Boolean,
    required: false,
    default: true,
  },
  spaceBetween: {
    type: Number,
    required: false,
    default: 24,
  },
  isModal: {
    type: Boolean,
    required: false,
    default: false,
  },
})
const { isMobile } = useDevice()
const items = props.isModal
  ? promotionModalItems
  : EVENT_ENABLE
  ? promotionItems
  : promotionItems.slice(1, promotionItems.length)
const { trackingPromotionClicked } = usePromotionalEngagement()

const toPromotionDetail = (promotion: HomePromotionItem) => {
  trackingPromotionClicked({
    promotionId: promotion.packageId,
    promotionName: promotion.name,
  })
  navigateTo(promotion.to)
}
</script>

<template>
  <div
    class="promotion-container"
    :class="{
      'promotion-container--mobile': isMobile,
      'promotion-container--mobile-modal': isMobile && isModal,
    }"
  >
    <BaseSection :title="title" :icon="icon">
      <Swiper
        :modules="modules"
        :pagination="{
          el: '.promotion-banners-pagination',
          clickable: true,
        }"
        :slides-per-view="
          isMobile
            ? isModal
              ? SlidersPerView.ExtraSmall
              : SlidersPerView.ExtremeSmall
            : SlidersPerView.MediumSmall
        "
        :space-between="spaceBetween"
        :loop="!isMobile"
        :slides-offset-before="isMobile && !isModal ? 16 : 0"
        :slides-offset-after="isMobile && !isModal ? 16 : 0"
        :resistance-ratio="0"
        :breakpoints="{
          425: {
            slidesPerView: SlidersPerView.MediumExtraSmall,
            spaceBetween: 12,
          },
          800: {
            slidesPerView: SlidersPerView.MediumSmall,
            spaceBetween: 16,
          },
        }"
      >
        <SwiperSlide v-for="(promotion, index) in items" :key="index">
          <a :href="promotion.to" @click.prevent="toPromotionDetail(promotion)">
            <div class="promotion-container__image">
              <img
                :src="
                  isMobile && promotion.imgSrcMB
                    ? promotion.imgSrcMB
                    : promotion.imgSrc
                "
                :alt="promotion.name"
                :width="isMobile ? '256' : '432'"
                :height="isMobile ? '86' : '171'"
                loading="lazy"
              />
            </div>
          </a>
        </SwiperSlide>
        <div v-if="isMobile && isModal" class="promotion-banners-pagination" />
      </Swiper>
      <template v-if="hasViewMore" #right-action>
        <NuxtLink
          :to="PromotionRouteEnum.Promotion"
          class="v-btn v-theme--light v-btn--density-default v-btn--size-small v-btn--variant-text base-button v-btn--text"
          :class="{
            'promotion-container__button': isMobile,
          }"
          button-id="load-more-promotion"
          button-name="load-more-promotion"
        >
          <span class="v-btn__content">Xem thêm</span>
        </NuxtLink>
      </template>
    </BaseSection>
  </div>
</template>
<style scoped lang="scss">
@import '~/assets/styles/components/desktop/home/promotion.scss';
</style>
